<template>
  <svg xmlns="http://www.w3.org/2000/svg"
       width="100%"
       height="100%"
       viewBox="0 0 12 16"
       xml:space="preserve"
       class="fill-current"
  >
    <g transform="matrix(1.88562,0,0,1.88562,-1.38784,-1.05807)">
        <path
          d="M1.572,9L1.572,7.548L3.984,7.548C4.376,7.548 4.684,7.452 4.908,7.26C5.132,7.06 5.244,6.796 5.244,6.468C5.244,6.124 5.12,5.852 4.872,5.652C4.624,5.452 4.284,5.356 3.852,5.364L1.572,5.364L1.572,4.092L3.024,4.116C3.808,4.116 4.492,4.204 5.076,4.38C5.66,4.548 6.112,4.812 6.432,5.172C6.76,5.532 6.924,6.008 6.924,6.6C6.924,7.112 6.808,7.548 6.576,7.908C6.344,8.268 6.02,8.54 5.604,8.724C5.188,8.908 4.7,9 4.14,9L1.572,9ZM0.912,9L0.912,0.6L2.52,0.6L2.52,9L0.912,9ZM1.512,5.448L1.512,4.02L3.792,4.02C4.152,4.02 4.436,3.928 4.644,3.744C4.852,3.56 4.956,3.3 4.956,2.964C4.956,2.628 4.84,2.368 4.608,2.184C4.376,1.992 4.06,1.9 3.66,1.908L1.512,1.908L1.512,0.612L3.756,0.588C4.332,0.588 4.836,0.68 5.268,0.864C5.7,1.04 6.036,1.308 6.276,1.668C6.516,2.02 6.636,2.46 6.636,2.988C6.636,3.42 6.488,3.812 6.192,4.164C5.904,4.516 5.496,4.796 4.968,5.004C4.448,5.212 3.84,5.316 3.144,5.316L1.512,5.448Z"
        />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'BoldIcon'
}
</script>
